import React from "react";
import { Locale } from "@linkfluence/models/locale";
import { Fieldset, Label } from "@ui-kit/form";
import Input from "@ui-kit/form/text/index";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { editAuthorIdOnCard } from "@radarly/models/cards/editor";
import { PinnedAuthorCard } from "@radarly/models/cards/model";

export interface SharedPanelsCardEditionSidebarPinnedAuthorProps {
  card: PinnedAuthorCard;
  setCard: (card: Card) => void;
  locale: Locale;
}

export default function SharedPanelsCardEditionSidebarPinnedAuthor({
  card,
  setCard,
  locale,
}: SharedPanelsCardEditionSidebarPinnedAuthorProps) {
  return (
    <>
      <Fieldset>
        <Label htmlFor="name">
          {tr(locale, "INSIGHT_PAGES::EDITOR::AUTHOR_ID")}
        </Label>
        <Input
          value={card.fragments[0].authorId}
          onChange={(authorId) => setCard(editAuthorIdOnCard(card, authorId))}
          placeholder={tr(
            locale,
            "INSIGHT_PAGES::EDITOR::AUTHOR_ID_PLACEHOLDER"
          )}
        />
      </Fieldset>
    </>
  );
}
